// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1tl0D","title":"Header_title___N7lx","side":"Header_side__1eGZ1"};